// Marcels sociale kanalen. Één bron van waarheid voor UI-links én JSON-LD sameAs.
export const SOCIALS = [
    {
        key: "facebook",
        label: "Facebook van Human Design Studio",
        url: "https://www.facebook.com/humdesstudio",
    },
    {
        key: "instagram",
        label: "Instagram van Human Design Studio",
        url: "https://www.instagram.com/studio.humandesign/",
    },
];

export const SOCIAL_URLS = SOCIALS.map((s) => s.url);
